import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { bootstrapEcoBox, createSessionEngine, getPref } from '@ecobox/firebase';
import { applyTheme } from '@ecobox/ui';
import './index.css';
import { App } from './App';
import { warmUpScanner } from './scanner/detector';
import { APP_VERSION, ECOBOX_ENV, firebaseConfig } from './env';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root is missing from index.html');
const root = createRoot(rootEl);

applyTheme(getPref('theme'));

bootstrapEcoBox({
  env: ECOBOX_ENV,
  firebaseConfig: firebaseConfig(),
  appVersion: APP_VERSION,
  // Ops devices never evict what they have read: they may be offline for days.
  cache: 'unlimited',
})
  .then((services) => {
    // Scan sessions live on the phone for as long as the app runs, like the services.
    const engine = createSessionEngine({
      writer: services.writer,
      connectivity: services.connectivity,
    });
    root.render(
      <StrictMode>
        <App services={services} engine={engine} />
      </StrictMode>,
    );
    if (navigator.onLine) void warmUpScanner();
    if (import.meta.env.PROD && 'serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/sw.js')
        .catch((err: unknown) => console.warn('Offline shell could not be installed.', err));
    }
  })
  .catch((err: unknown) => {
    console.error('EcoBox Ops could not start.', err);
    root.render(
      <p role="alert" style={{ padding: 24 }}>
        EcoBox Ops could not start: {err instanceof Error ? err.message : String(err)}
      </p>,
    );
  });
